import React from 'react';
import FormBuilder from './FormBuilder';
import { Input, Checkbox, Switch, Button, Select, InputNumber, Radio, DatePicker } from 'antd';
import _ from 'lodash';
import DatePickerField from './Fields/DatePicker';

const mapOptions = (options: any) => {
    if (!_.isArray(options)) {
        throw new Error('Options should be array in form builder meta.');
    }
    return options.map(opt => {
        if (_.isArray(opt)) {
            return { value: opt[0], label: opt[1] };
        } else if (_.isPlainObject(opt)) {
            return opt;
        } else {
            return { value: opt, label: opt };
        }
    });
};

FormBuilder.prototype.defineWidget('checkbox', Checkbox, (field: any) => {
    return { ...field, valuePropName: 'checked' };
});
FormBuilder.prototype.defineWidget('switch', Switch, (field: any) => {
    return { ...field, valuePropName: 'checked' };
});

FormBuilder.prototype.defineWidget('button', Button);
FormBuilder.prototype.defineWidget('input', Input);
FormBuilder.prototype.defineWidget('password', Input.Password);
FormBuilder.prototype.defineWidget('textarea', Input.TextArea);
FormBuilder.prototype.defineWidget('number', InputNumber);
FormBuilder.prototype.defineWidget('date-picker', DatePicker);
FormBuilder.prototype.defineWidget('radio', Radio);
FormBuilder.prototype.defineWidget('radio-group', Radio.Group, (field: any) => {
    const RadioComp = field.buttonGroup ? Radio.Button : Radio;
    if (field.options && !field.children) {
        return {
            ...field,
            widgetProps: {
                ...field.widgetProps,
                name: field.key,
            },
            children: mapOptions(field.options).map(opt => (
                <RadioComp value={opt.value} key={opt.value}>
                    {opt.label}
                </RadioComp>
            )),
        };
    }
    return field;
});

FormBuilder.prototype.defineWidget('checkbox-group', Checkbox.Group, (field: any) => {
    if (field.options && !field.children) {
        return {
            ...field,
            children: mapOptions(field.options).map(opt => (
                <Checkbox value={opt.value} key={opt.value}>
                    {opt.label}
                </Checkbox>
            )),
        };
    }
    return field;
});
FormBuilder.prototype.defineWidget('select', Select, (field: any) => {
    const searchSetting = {
        showSearch: Array.isArray(field.options) && (field.options.length > 10),
        optionFilterProp: "children",
        filterOption: (input: string, option: any) => {
            const text = option.props.children;
            return (typeof text === 'string' ? text : text[0]).toLowerCase().includes(input.toLowerCase());
        },
    };
    if (field.options && !field.children) {
        return {
            ...field,
            ...searchSetting,
            children: mapOptions(field.options).map(opt => (
                <Select.Option label={opt.label} value={opt.value} key={opt.value} disabled={opt.disabled}>
                    {opt.children || opt.label}
                </Select.Option>
            )),
        };
    }
    return {
        ...field,
        ...searchSetting,
    };
});
FormBuilder.prototype.defineWidget('datePicker', DatePickerField);
